module.exports = __webpack_public_path__ + "media/images/front/about/thumbnail3-53eed296447bef118943a2a12493c26a.jpg";